/* eslint-disable semi,semi-style */

export default [
  {
    title: '桩企接入',
    node: 'appsub',
    path: '/direct',
    exact: false,
    desc: '查看桩企接入开发文档，操作桩设备接入联调测试',
    nebulaModule: 'direct',
    basename: '/direct',
    isSubApp: true,
  },
  {
    title: '互通互联接入',
    node: 'root',
    path: '/join',
    exact: false,
    desc: '查看互联互通接入开发文档，自助操作加盟运营商接入服务',
    isAbandon: true,
  },
  {
    title: '反向互通互联接入',
    node: 'appsub',
    path: '/comming',
    exact: true,
    desc: '查看反向互联互通接入开发文档，接入滴滴充电充电桩信息和充电服务',
  },
  {
    title: 'H5自助接入',
    node: 'app',
    path: '/h5',
    exact: false,
    hidden: true,
    desc: '查看滴滴充电H5接入文档，自助接入充电H5页面',
    imgIndex: 7,
  },
  {
    title: '刷卡接入',
    node: 'appsub',
    path: '/comming',
    exact: true,
    desc: '查看刷卡开发文档，自助操作刷卡流程联调测试',
    imgIndex: 4,
  },
];
